import { defineMessages } from 'react-intl'

export default defineMessages({
  noAvailableVariables: {
    id: 'SpaceAppBuilder.VariableInput.noAvailableVariables',
    defaultMessage: 'No available variables for this field'
  }
})
